import * as types from 'model/actionTypes'
import { AccountT } from 'shared/types/model'

export function receiveAccount (account: AccountT | null) {
  return {
    type: types.RECEIVE_ACCOUNT,
    account
  }
}
